import Route from '@ember/routing/route';

export default class WorkplaceApprovalsIndexRoute extends Route {
  // No model or services needed - React component will handle its own data
}
